import React from 'react';

const StarRating = ({
  rating = 0,
  maxRating = 5,
  onChange,
  readonly = false,
  size = 'default',
  className = ''
}) => {
  const [hoverRating, setHoverRating] = React.useState(0);

  const sizes = {
    small: 'w-6 h-6',
    default: 'w-8 h-8',
    large: 'w-10 h-10'
  };

  const sizeClass = sizes[size] || sizes.default;

  const handleClick = (value) => {
    if (!readonly && onChange) {
      onChange(value);
    }
  };

  const handleMouseEnter = (value) => {
    if (!readonly) {
      setHoverRating(value);
    }
  };

  const handleMouseLeave = () => {
    if (!readonly) {
      setHoverRating(0);
    }
  };

  const displayRating = hoverRating || rating;

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {[...Array(maxRating)].map((_, index) => {
        const starValue = index + 1;
        const isFilled = starValue <= displayRating;

        return (
          <button
            key={index}
            type="button"
            onClick={() => handleClick(starValue)}
            onMouseEnter={() => handleMouseEnter(starValue)}
            onMouseLeave={handleMouseLeave}
            disabled={readonly}
            className={`
              ${sizeClass}
              ${readonly ? 'cursor-default' : 'cursor-pointer'}
              transition-colors duration-150
              focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2
              rounded
              disabled:cursor-default
            `}
            aria-label={`${starValue} stea${starValue > 1 ? 'le' : ''}`}
          >
            <svg
              viewBox="0 0 24 24"
              fill={isFilled ? '#fbbf24' : 'none'}
              stroke={isFilled ? '#fbbf24' : '#d1d5db'}
              strokeWidth="1.5"
              className={`${sizeClass} ${!readonly && 'hover:scale-110'} transition-transform duration-150`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
              />
            </svg>
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;
